"use strict";
import { Action } from "../actions";
export default function documentPageIdReducer(id = null, action) {
  switch (action.type) {
    case Action.LOADING_ANNOTATIONS: {
      return action.id;
    }
    default:
      return id;
  }
}
